<template>
  <GlassPreviewLayout>
    <div class="image">
      <Image :image-url="imageUrl" />
    </div>
    <slot></slot>
  </GlassPreviewLayout>
</template>
<script>
import useProduct from "../../useProduct";
import GlassPreviewLayout from "./Layout";
import Image from "../Image";
import { mapGetters } from "vuex";

export default {
  components: {
    GlassPreviewLayout,
    Image
},
  computed: {
    ...mapGetters({
      product: "product/getProduct",
    }),
  },
  setup() {
    const { imageUrl } = useProduct();

    return {
      imageUrl,
    };
  },
};
</script>
